var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let resources = {};
let isLoaded = false;
function init() {
    return __awaiter(this, void 0, void 0, function* () {
        let culture = $('html').attr('lang');
        let resourceKey = `resources_${culture}`;
        let storeData = window.sessionStorage.getItem(resourceKey);
        if (storeData) {
            resources = JSON.parse(storeData);
        }
        if (!isLoaded) {
            isLoaded = true;
            resources = yield $.get(`/${culture.split('-')[0]}/Resources/ReadResources`);
            $.DirtyForms.message = resources.ConfirmLeaveMessage;
            window.sessionStorage.setItem(resourceKey, JSON.stringify(resources));
        }
    });
}
init();
export function getResource(key) {
    var _a;
    return (_a = resources[key]) !== null && _a !== void 0 ? _a : key;
}
